import React, { useEffect } from "react";
import {
  GetIntellipayWidget,
  PostIntellipayStoreSuccess,
} from "../services/PaymentService";
import { useAxiosInstance } from "../services/Interceptor";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const IntellipayStoreOnlyMode = (props) => {
  const apiInstance = useAxiosInstance();

  useEffect(() => {
    loadIntelliPayScript();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const resetIntellipayWidget = () => {
    window.__intellipayWidgetLoaded = false;
  };

  const loadIntelliPayScript = async () => {
    try {
      if (window.__intellipayWidgetLoaded && window.intellipay) return;

      const response = await GetIntellipayWidget(apiInstance);

      if (response.success && response.data) {
        const range = document.createRange();
        const fragment = range.createContextualFragment(response.data);

        if (!document.documentElement.contains(fragment)) {
          document.documentElement.appendChild(fragment);
        }

        if (window.intellipay) {
          window.intellipay.initialize();
          if (window.intellipay?.disable) {
            window.intellipay.disable("confirm");
          }
          window.intellipay.setStoreOnly(true);
          window.intellipay.runOnApproval(async (approvalResponse) => {
            const storeResponse = await PostIntellipayStoreSuccess(
              apiInstance,
              approvalResponse.custid,
            );

            if (storeResponse.success) {
              toast.success("Payment details updated successfully!", {
                position: "top-right",
              });

              if (typeof props.onStoreSuccess === "function") {
                await props.onStoreSuccess({
                  custId: approvalResponse.custid,
                  storeResponse,
                });
              }

              setTimeout(() => {
                props.onRegistrationSuccess?.();
              }, 1500);
            } else {
              toast.error("Failed to update payment details", {
                position: "top-right",
              });

              if (typeof props.onStoreFail === "function") {
                props.onStoreFail(storeResponse);
              }
            }
          });

          window.intellipay.runOnNonApproval((res) => {
            setTimeout(() => {
              props.onRegistrationSuccess?.();
            }, 1500);

            if (typeof props.onNonApproval === "function") {
              props.onNonApproval(res);
            }

            resetIntellipayWidget();
          });

          window.__intellipayWidgetLoaded = true;
        }
      } else {
        console.error("Failed to retrieve IntelliPay script from backend");
      }
    } catch (error) {
      console.error("Error loading IntelliPay script:", error);
    }
  };

  return (
    <div>
      <input
        className="ipayfield"
        data-ipayname="account"
        type="hidden"
        value={0}
      />
      <input
        className="ipayfield"
        data-ipayname="email"
        type="hidden"
        value={props.userEmail}
      />
    </div>
  );
};

export default IntellipayStoreOnlyMode;
